export const getErrors = (state) => {
  return state.error.errors;
};
